import gql from 'graphql-tag';
import { EVENT_FRAGMENT } from '../../fragments/event.fragment';

export const EVENT = gql`
  query DealActivity($input: CalendarEventInput!) {
    dealActivity {
      result: calendarEvent(input: $input) {
        error
        success
        entity {
          ...EventFields
        }
      }
    }
  }
  ${EVENT_FRAGMENT}
`;
